declare global {
    interface Window {
        env: {
            NODE_ENV: string
        }
    }
}
export { GlobalStyle } from './GlobalStyles.styled'
export {
    createThemeContract,
    createTheme,
    printThemesCss,
    getThemeStyles,
    getThemeCssContent,
    getThemeCss,
    createVar,
} from './lib/createTheme'
export { vars, mq, contract, hexToRgb } from './themeContract'
import { gel2LightTheme } from './gel2Theme'
import { gel3DarkTheme, gel3LightTheme } from './gel3Themes'

export { gel2LightTheme, gel3DarkTheme, gel3LightTheme }

type Falsey = false | undefined | 0 | null | ''
function filter<T>(array: T[]): (T extends Falsey ? never : T)[] {
    return array.filter(Boolean) as any
}

export const gel2Themes = [gel2LightTheme]
export const gel3Themes = filter([
    gel3LightTheme,
    typeof sessionStorage !== 'undefined' &&
        !!sessionStorage.getItem('GEL_ENABLE_DARK_MODE') &&
        gel3DarkTheme,
])

export const clsFlags = {
    error: 'error',
    disabled: 'disabled',
} as const
export { getSpacing, getTypeSize, marginMixin } from './lib/utils'
export { getBreakpoint } from './lib/getBreakpoint'
export { pxToEm, pxToRem } from './lib/pxToRem'
